document.addEventListener('DOMContentLoaded', () => {
  const timelineItems = Array.from(document.querySelectorAll('.psi-timeline__card'));
  let lastScrollY = window.scrollY;

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    const direction = currentScrollY > lastScrollY ? 'down' : 'up';
    const activationPoint = window.innerHeight * 0.9;

    timelineItems.forEach((item) => {
      const itemTop = item.getBoundingClientRect().top;

      if (direction === 'down') {
        if (itemTop < activationPoint) {
          item.classList.add('psi-timeline__card--active');
        }
      } else {
        if (itemTop > activationPoint) {
          item.classList.remove('psi-timeline__card--active');
        }
      }
    });

    lastScrollY = currentScrollY;
  };

  window.addEventListener('scroll', () => {
    window.requestAnimationFrame(handleScroll);
  });

  if (timelineItems) {
    handleScroll();
  }
});
